module.exports = __webpack_public_path__ + "static/media/logo_amazon-glue.5924189b.svg";